import { render, staticRenderFns } from "./ViSchools.vue?vue&type=template&id=8a1beb18&scoped=true"
import script from "./ViSchools.vue?vue&type=script&lang=js"
export * from "./ViSchools.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a1beb18",
  null
  
)

export default component.exports